// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2dpbQ","top":"styles_top__QSrfw"};